import React from "react";
import { CollapsibleContainer } from "../../Components/Helpers/CollapsibleContainer";

interface PatientQuoteCardAdditionalQuotesProps {
  additionalQuotes: string[];
}

export const PatientQuoteCardAdditionalQuotes: React.FC<
  PatientQuoteCardAdditionalQuotesProps
> = ({ additionalQuotes }) => {
  return !!additionalQuotes.length ? (
    <CollapsibleContainer
      content={additionalQuotes
        .map((quote) => `<p>&#8220;${quote}&#8221;</p>`)
        .join("")}
      id="patient-quotes"
      normalButton={true}
    />
  ) : null;
};
